<template>
  <!-- Create a navbar that will be called and utilized in every component page -->
  <nav class="navbar is-black">
    <div class="navbar-brand">
      <a class="navbar-item" href="http://www.knosishealth.com" title="KNOSIS Website Home">
        <img src="../../assets/knosisTRANSPARENT.png" alt="KNOSIS">
      </a>
      <div class="navbar-burger burger" @click="showNav = !showNav" :class="{ 'is-active': showNav }">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <div class="navbar-menu" :class="{ 'is-active': showNav }">
      <div class="navbar-start">
      </div>

      <div class="navbar-end">
        <br><br><br><a class="navbar-item is-active" @click="goToMessagingPage">MESSAGING</a>
        <a class="navbar-item is-active" @click="goToGroupDataPage">GROUP DATA</a>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">More</a>
          <div class="navbar-dropdown is-boxed is-right">
            <hr class="navbar-divider">
            <a class="navbar-item" @click="logout">LOGOUT</a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import * as firebase from 'firebase'

export default {
  name: 'adminNavbar',
  data () {
    return {
      showNav: false,
    }
  },
  components: {
  },
  methods: {
    logout() {
      this.$store.dispatch('logoutAdmin')  // call the logout method from the store
      this.$router.push({path: '/login'})
    },
    goToGroupDataPage() {
      this.showNav = false
      this.$router.push({path: '/adminGroupData'})
    },
    goToMessagingPage() {
      this.showNav = false
      this.$router.push({path: '/adminMessaging'})
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar {
    background-color: black;
    navbar-burger-color: black;
}
.navbar-burger {
  background-color: transparent;
  color: white;
  padding-top: 55px;
}
.navbar .navbar-brand .navbar-item {
  color: white;
  font-size: 14px;
  padding-top: 8%;
}
.navbar .navbar-menu .navbar-end .navbar-item:hover {
  color: purple;
}
@media only screen and (max-width: 1023px) {
  .navbar .navbar-brand .navbar-item {
    color: white;
    font-size: 14px;
    padding-top: 4%;
  }

  .burger-dropdown-position {
    margin-top: 40px;
    text-align: right;
  }

  /* Positions the burger */
  .burger {
      position: relative;
      margin-top: -15px;
      padding-right: 55px;
      z-index: 100;
      display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/adminNavbar.vue